"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brenzone-sul-garda": {
    "6ba702de": [{
      "hkey": "44248f20",
      "slug": "brenzone-sul-garda",
      "name": "Brenzone sul Garda",
      "primary": true,
      "skipSearch": false
    }],
    "castelletto-di-brenzone": [{
      "hkey": "44248f20",
      "slug": "brenzone-sul-garda",
      "name": "Brenzone sul Garda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;